module.exports = __webpack_public_path__ + "img/img6.e2539a3a.svg";